"use client";

import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import { type FC } from "react";
import { useState } from "react";

import { SearchAutocompleteDialog } from "~/feature/search/components/SearchAutocompleteDialog";

export const MobileSearch: FC = () => {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <>
      <IconButton
        size="medium"
        aria-label="open search"
        onClick={() => setSearchOpen(true)}
      >
        <SearchIcon />
      </IconButton>
      <SearchAutocompleteDialog
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
      />
    </>
  );
};
